import React from "react";
import { SiGmail } from "react-icons/si";
import "./TeamMem.css";
import TeamMember from "./TeamMember";
export default function TeamMembers() {
  return (
    <div>
      <>
        <div className="container flex justify-center">
          <div style={{ justifyContent: "center" }} className="flex flex-wrap max-w-screen-lg">
            <TeamMember 
                        email={"mailto:iabro@student.ubc.ca"}
                        linkedin={"https://www.linkedin.com/in/ibaadabro/"}
                        name={"Ibaad Abro"}
                        title={"Captain"}
            />
            <TeamMember 
                        email={"mailto:rrueda@student.ubc.ca"}
                        linkedin={"https://www.linkedin.com/in/ryza-rueda"}
                        name={"Ryza Rueda"}
                        title={"Captain"}
            />     
            <TeamMember
                        email={"mailto:clyeung@student.ubc.ca"}
                        linkedin={"https://www.linkedin.com/in/clement-ly-yeung-b056aa394/"}
                        name={"Clement Yeung"}
                        title={"Chemical Lead"}
            />
            <TeamMember 
                        email={"mailto:ggracey3@student.ubc.ca"}
                        linkedin={"https://www.linkedin.com/in/gus-gracey-4bb699382/"}
                        name={"Gus Gracey"}
                        title={"Chemical Lead"}
            />
            <TeamMember 
                        email={"mailto:corashao@student.ubc.ca"}
                        linkedin={"https://www.linkedin.com/in/cora-shao-ece/"}
                        name={"Cora Shao"}
                        title={"Electrical Lead"}
            />
            <TeamMember 
                        email={"mailto:acheng84@student.ubc.ca"}
                        linkedin={"https://www.linkedin.com/in/alan-chengg/"}
                        name={"Alan Cheng"}
                        title={"Electrical Lead"}
            />
            <TeamMember 
                        email={"mailto:amlee27@student.ubc.ca"}
                        linkedin={"https://www.linkedin.com/in/amber-lee-8a327a302/"}
                        name={"Amber Lee"}
                        title={"Mechanical Lead"}
            />
             <TeamMember 
                        email={"mailto:kwong002@student.ubc.ca"}
                        linkedin={"https://www.linkedin.com/in/kevinwong4947/"}
                        name={"Kevin Wong"}
                        title={"Mechanical Lead"}
            /> 
             <TeamMember 
                        email={"mailto:sqian18@student.ubc.ca"}
                        linkedin={"https://www.linkedin.com/in/stephanie-qian-020a74303/"}
                        name={"Stephanie Qian"}
                        title={"Operations Lead"}
            /> 
          </div>
        </div>
      </>
    </div>
  );
}
